import { defineMessages } from 'react-intl';

export default defineMessages({
  freeGift: {
    id: 'GiftWrapper.freeGift',
    defaultMessage: 'Free Gift',
  },
  freeGiftEnhanced: {
    id: 'GiftWrapper.freeGiftEnhanced',
    defaultMessage: 'Upgrade Your Gift',
  },
  productdetails: {
    id: 'GiftWrapper.productdetails',
    defaultMessage: 'Product Details',
  },
  completeYourSetTitle: {
    id: 'GiftWrapper.completeYourSet.title',
    description: 'Title for "complete your set" block',
    defaultMessage: 'Complete Your Set',
  },
  toggleProductDetailsAlt: {
    id: 'GiftWrapper.toggleProductDetailsAlt',
    description: 'Toggle Product Details alt text',
    defaultMessage: 'Toggle Product Details',
  }
});
